exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".a5dbfc{font-size:2.25em;position:relative;cursor:pointer}.af03fa{font-size:1.75em}.f47d1c.edd280{transform:translateY(-0.5em);opacity:0}.f47d1c._6933fb{transition:.25s .25s cubic-bezier(0.175, 0.885, 0.32, 1.275);transform:translateY(0);opacity:1}.f47d1c._2f609d{transition:.25s;opacity:0;transform:translateY(-0.5em)}.f47d1c p{margin-top:1.375rem}._4bda09{border-top:1px solid;opacity:.15}@media screen and (min-width: 0){._4bda09{margin:2.0625rem 0}}@media screen and (min-width: 640px){._4bda09{margin:2.75rem 0}}@media screen and (min-width: 992px){._4bda09{margin:3.4375rem 0}}._4c802a{width:1em;height:1em;vertical-align:middle;position:absolute;top:50%;right:100%;margin-top:-0.5em;margin-right:.5em}._4c802a path{transform-origin:50% 50%;transition:.3s}._4c802a .a2d961.d84082{transform:rotate(270deg)}._4c802a .d982cf.d84082{transform:rotate(180deg)}.cc567b{right:0;transform:scale(0.5) scaleY(-1);transform-origin:100%;transition:transform .2s;margin-right:0;opacity:.333}.cc567b.da3381{transform:scale(0.5) scaleY(1)}", ""]);
// Exports
exports.locals = {
	"title": "a5dbfc",
	"faqTitle": "af03fa a5dbfc",
	"item": "f47d1c",
	"enter": "edd280",
	"enterActive": "_6933fb",
	"exit": "_2f609d",
	"separator": "_4bda09",
	"icon": "_4c802a",
	"first": "a2d961",
	"off": "d84082",
	"second": "d982cf",
	"chevron": "cc567b _4c802a",
	"on": "da3381"
};